(function ($) {
    'use strict';

    const focusable = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function initMenu(scope) {
        const container = scope || document;
        const roots = Array.from(container.querySelectorAll('.n3auto-menu'));
        if (container.matches && container.matches('.n3auto-menu')) roots.unshift(container);

        roots.forEach(function (root) {
            if (typeof root.n3autoSyncMode === 'function') {
                root.n3autoSyncMode();
                return;
            }

            root.dataset.n3autoReady = '1';
            const panel = root.querySelector('.n3auto-menu__panel');
            const toggle = root.querySelector('.n3auto-menu__toggle');
            const close = root.querySelector('.n3auto-menu__close');
            const overlay = root.querySelector('.n3auto-menu__overlay');
            const breakpoint = parseInt(root.dataset.breakpoint || '1024', 10);
            const mediaQuery = window.matchMedia('(max-width: ' + breakpoint + 'px)');
            let previousFocus = null;

            root.querySelectorAll('.menu-item-has-children').forEach(function (item, index) {
                const submenu = Array.from(item.children).find(function (child) { return child.classList && child.classList.contains('sub-menu'); });
                if (!submenu || Array.from(item.children).some(function (child) { return child.classList && child.classList.contains('n3auto-menu__submenu-toggle'); })) return;
                if (!submenu.id) submenu.id = root.id + '-submenu-' + index;
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'n3auto-menu__submenu-toggle';
                button.setAttribute('aria-expanded', 'false');
                button.setAttribute('aria-controls', submenu.id);
                button.setAttribute('aria-label', 'Toggle submenu');
                item.insertBefore(button, submenu);
                button.addEventListener('click', function () {
                    const open = item.classList.toggle('is-submenu-open');
                    button.setAttribute('aria-expanded', open ? 'true' : 'false');
                });
            });

            function setOpen(open) {
                if (!toggle || !panel) return;
                root.classList.toggle('is-open', open);
                toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
                panel.setAttribute('aria-hidden', open ? 'false' : 'true');
                if (overlay) overlay.hidden = !open;
                document.body.classList.toggle('n3auto-menu-lock', open);
                if (open) {
                    previousFocus = document.activeElement;
                    const first = panel.querySelector(focusable);
                    if (first) first.focus();
                } else if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
            }

            function syncMode() {
                if (!root.isConnected || !root.classList.contains('has-offcanvas') || !panel || !toggle) return;
                const mobile = mediaQuery.matches;
                root.classList.toggle('is-mobile', mobile);
                root.classList.toggle('is-desktop', !mobile);
                if (mobile) {
                    panel.setAttribute('aria-hidden', root.classList.contains('is-open') ? 'false' : 'true');
                    if (!root.classList.contains('is-open') && overlay) overlay.hidden = true;
                    return;
                }
                root.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
                panel.removeAttribute('aria-hidden');
                if (overlay) overlay.hidden = true;
                document.body.classList.remove('n3auto-menu-lock');
            }

            root.n3autoSyncMode = syncMode;
            if (toggle) toggle.addEventListener('click', function () { setOpen(!root.classList.contains('is-open')); });
            if (close) close.addEventListener('click', function () { setOpen(false); });
            if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
            panel && panel.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') { event.preventDefault(); setOpen(false); return; }
                if (event.key !== 'Tab' || !root.classList.contains('is-open')) return;
                const nodes = Array.from(panel.querySelectorAll(focusable)).filter(function (node) { return node.offsetParent !== null; });
                if (!nodes.length) return;
                const first = nodes[0], last = nodes[nodes.length - 1];
                if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
                else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
            });
            window.addEventListener('resize', syncMode, { passive: true });
            window.addEventListener('orientationchange', syncMode, { passive: true });
            window.addEventListener('pageshow', syncMode);
            window.addEventListener('load', syncMode, { once: true });
            if (window.visualViewport) window.visualViewport.addEventListener('resize', syncMode, { passive: true });
            if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', syncMode);
            else if (mediaQuery.addListener) mediaQuery.addListener(syncMode);
            syncMode();
            window.requestAnimationFrame(syncMode);
            window.setTimeout(syncMode, 100);
        });
    }
    function updateCompare(scope) {
        (scope || document).querySelectorAll('.n3auto-header-compare').forEach(function (link) {
            let ids = [];
            try { ids = JSON.parse(localStorage.getItem(link.dataset.storageKey || 'n3auto_compare_listings') || '[]'); } catch (e) { ids = []; }
            const count = link.querySelector('.n3auto-header-action__count');
            if (count) count.textContent = Array.isArray(ids) ? ids.filter(Boolean).length : 0;
        });
    }

    function initHeaderAccount(scope) {
        (scope || document).querySelectorAll('.n3auto-header-account--dashboard:not([data-account-ready])').forEach(function (root) {
            root.dataset.accountReady = '1';
            const toggle = root.querySelector('.n3auto-header-account__toggle');
            const dropdown = root.querySelector('.n3auto-header-account__dropdown');

            if (!toggle || !dropdown) return;

            function setOpen(open) {
                root.classList.toggle('is-open', open);
                toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
                dropdown.setAttribute('aria-hidden', open ? 'false' : 'true');
            }

            toggle.addEventListener('click', function (event) {
                event.preventDefault();
                setOpen(!root.classList.contains('is-open'));
            });

            root.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    setOpen(false);
                    toggle.focus();
                }
            });

            document.addEventListener('click', function (event) {
                if (!root.contains(event.target)) setOpen(false);
            });
        });
    }

    function initBrands(scope) {
        (scope || document).querySelectorAll('.n3auto-brand-logos.is-slider:not([data-slider-ready])').forEach(function (root) {
            if (typeof Swiper === 'undefined') return;
            root.dataset.sliderReady = '1';
            let options = {}; try { options = JSON.parse(root.dataset.brandOptions || '{}'); } catch (e) { options = {}; }
            const per = options.slidesPerView || {};
            const gap = options.spaceBetween || {};
            root.n3autoSwiper = new Swiper(root, {
                slidesPerView: per.mobile || 2,
                spaceBetween: gap.mobile || 16,
                loop: !!options.loop,
                autoplay: options.autoplay ? { delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
                watchOverflow: true,
                breakpoints: { 768: { slidesPerView: per.tablet || 4, spaceBetween: gap.tablet || 24 }, 1025: { slidesPerView: per.desktop || 7, spaceBetween: gap.desktop || 32 } }
            });
        });
    }

    function initNewsletter(scope) {
        (scope || document).querySelectorAll('.n3auto-footer-newsletter:not([data-form-ready])').forEach(function (root) {
            root.dataset.formReady = '1';
            const form = root.querySelector('form');
            const input = root.querySelector('[name="email"]');
            const button = root.querySelector('button[type="submit"]');
            const message = root.querySelector('.n3auto-footer-newsletter__message');
            if (!form) return;
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                message.className = 'n3auto-footer-newsletter__message'; message.textContent = '';
                if (!input || !input.validity.valid) { message.classList.add('is-error'); message.textContent = (window.n3auto_header_footer_vars || {}).invalidEmail || 'Please enter a valid email address.'; return; }
                button.disabled = true; button.classList.add('is-loading');
                fetch((window.n3auto_header_footer_vars || {}).ajaxUrl || window.ajaxurl, { method: 'POST', credentials: 'same-origin', body: new FormData(form) })
                    .then(function (response) { return response.json(); })
                    .then(function (result) {
                        if (!result || !result.success) throw new Error(result && result.data && result.data.message ? result.data.message : 'error');
                        message.classList.add('is-success');
                        message.textContent = result.data && result.data.duplicate ? root.dataset.duplicate : (root.dataset.success || result.data.message);
                        if (!(result.data && result.data.duplicate)) form.reset();
                    })
                    .catch(function (error) { message.classList.add('is-error'); message.textContent = error.message !== 'error' ? error.message : ((window.n3auto_header_footer_vars || {}).errorMessage || 'Something went wrong.'); })
                    .finally(function () { button.disabled = false; button.classList.remove('is-loading'); });
            });
        });
    }

    function init(scope) {
        const element = scope && scope[0] ? scope[0] : (scope || document);
        initMenu(element); initHeaderAccount(element); initBrands(element); initNewsletter(element); updateCompare(element);
    }

    $(function () { init(document); });
    window.addEventListener('storage', function (event) { if (event.key === 'n3auto_compare_listings') updateCompare(document); });
    document.addEventListener('n3auto:compare:updated', function () { updateCompare(document); });
    $(document).on('click', '.n3auto-archive-compare, .n3auto-compare-toggle, .n3auto-compare-drawer-remove, .n3auto-listing-compare__button', function () { window.setTimeout(function () { updateCompare(document); }, 80); });
    $(window).on('elementor/frontend/init', function () {
        if (!window.elementorFrontend || !elementorFrontend.hooks) return;
        ['n3auto-site-logo','n3auto-menu','n3auto-header-compare','n3auto-header-cart','n3auto-header-account','n3auto-footer-app-promo','n3auto-footer-promo-cards','n3auto-footer-contact-strip','n3auto-brand-logos','n3auto-footer-about','n3auto-social-links','n3auto-footer-newsletter','n3auto-media-badges','n3auto-footer-bottom'].forEach(function (name) {
            elementorFrontend.hooks.addAction('frontend/element_ready/' + name + '.default', init);
        });
    });
})(jQuery);
